export const countries = {
  gp: {
    description:
      "Το νησί της πεταλούδας, προσφέροντας πλούσιο πολιτισμό και το επιβλητικό ηφαίστειο.",
    landmarks: [
      "Ηφαίστειο La Soufrière",
      "Παραλία Grande Anse",
      "Καταρράκτες Καμπέτ",
    ],
    gastronomy: "Τηγανίτες μπακαλιάρου, κοτόπουλο κολόμπο.",
  },
  mq: {
    description:
      "Το μαγευτικό και παγκοσμίως διάσημο Νησί των Λουλουδιών της Καραϊβικής.",
    landmarks: ["Όρος Πελέ", "Βοτανικός Κήπος Balata", "Βράχος Διαμαντιών"],
    gastronomy: "Καπνιστό κοτόπουλο, κρεολική καρύδα.",
  },
  gf: {
    description: "Η πύλη της Ευρώπης στο διάστημα και καταφύγιο του Αμαζονίου.",
    landmarks: ["Διαστημικό Κέντρο", "Νησιά της Σωτηρίας", "Έλη του Kaw"],
    gastronomy: "Ζωμός Awara, φρικασέ αγρίων θηραμάτων.",
  },
  re: {
    description:
      "Ένα ηφαιστειακό κόσμημα του Ινδικού Ωκεανού που συνδυάζει γαλαζοπράσινες λιμνοθάλασσες.",
    landmarks: ["Piton de la Fournaise", "Mafate Cirque", "Piton des Neiges"],
    gastronomy: "Ρουγκάιλ από λουκάνικο, κοτόπουλο κάρυ, σαμόσα.",
  },
  yt: {
    description:
      "Το νησί των αρωμάτων που περιβάλλεται από μια τεράστια και παρθένα λιμνοθάλασσα.",
    landmarks: ["Λιμνοθάλασσα της Μαγιότ", "Mount Choungui", "Παραλία N'Gouja"],
    gastronomy: "Σουβλάκια από zebu, Mataba (φύλλα μανιόκας).",
  },
  pf: {
    description:
      "Παράδεισος του Ειρηνικού, διάσπαρτη με πάνω από το νερό μπανγκαλόου και πολύτιμους κοραλλιογενείς υφάλους.",
    landmarks: ["Λιμνοθάλασσα Μπόρα Μπόρα", "Βουνό Otemanu", "Κόλπος του Κουκ"],
    gastronomy: "Ωμό ψάρι σε γάλα καρύδας, φάφαρου, επιδόρπιο poe.",
  },
  nc: {
    description:
      "Μια γη αντιθέσεων με τη μεγαλύτερη κλειστή λιμνοθάλασσα στον κόσμο.",
    landmarks: ["Φάρος Amédée", "Heart of Voh", "Oro Bay"],
    gastronomy: "Παραδοσιακό κανάκικο Bougna, σαλάτα ζαρκαδιού.",
  },
  ic: {
    description:
      "Ένα αρχιπέλαγος απέραντης αιώνιας άνοιξης σμιλεμένο από σεληνιακά ηφαιστειακά τοπία.",
    landmarks: ["Εθνικό Πάρκο Teide", "Αμμόλοφοι Maspalomas", "Timanfaya"],
    gastronomy: "Papas arrugadas, σάλτσα mojo, μαγειρευτό ψάρι sancocho.",
  },
  ptm: {
    description:
      "Το νησί της άνοιξης που βυθίζεται εντυπωσιακά και κατακόρυφα στον Ατλαντικό.",
    landmarks: ["Pico do Arieiro", "Cabo Girão", "Μονοπάτια Levadas"],
    gastronomy: "Espetada, ψωμί bolo do caco, μαύρο ξιφία.",
  },
  pta: {
    description:
      "Ένα παρθένο ωκεάνιο καταφύγιο όπου οι εντυπωσιακοί ηφαιστειακοί κρατήρες σχηματίζουν λίμνες.",
    landmarks: ["Λίμνες Sete Cidades", "Όρος Πίκο", "Θερμές πηγές Furnas"],
    gastronomy: "Στιφάδο Cozido das Furnas, τυρί São Jorge.",
  },
  aw: {
    description:
      "Αέρηδες σαρώνουν τεράστιες εκτάσεις κατάλευκης άμμου σε αυτό το πολύχρωμο.",
    landmarks: ["Εθνικό Πάρκο Arikok", "Eagle Beach", "Φάρος Καλιφόρνιας"],
    gastronomy: "Keshi Yena (γεμιστό τυρί), γλύκισμα pastechi, κατσικάκι.",
  },
  cw: {
    description:
      "Διάσημο για τους κρυστάλλινους κρυμμένους όρμους και την Ολλανδική αρχιτεκτονική της πόλης.",
    landmarks: [
      "Γέφυρα Queen Emma",
      "Playa Porto Mari",
      "Εθνικό Πάρκο Christoffel",
    ],
    gastronomy: "Karni stoba μοσχαρίσιο στιφάδο, τηγανίτες.",
  },
  sx: {
    description:
      "Η μαγευτική Φιλική Νήσος με δραματικά αεροπλάνα να χαϊδεύουν την υπέροχη παραλία.",
    landmarks: ["Maho Beach", "Pic Paradis", "Orient Bay"],
    gastronomy: "Παϊδάκια BBQ, ταξιδιωτικά κέικ, καβούρι.",
  },
  bm: {
    description:
      "Ένα μυθικό και ευγενές αρχιπέλαγος με όμορφες και συναρπαστικές παραλίες.",
    landmarks: [
      "Horseshoe Bay Beach",
      "Κρυστάλλινα Σπήλαια",
      "Gibbs Hill Lighthouse",
    ],
    gastronomy: "Ψαρόσουπα Βερμούδων με σκούρο ρούμι.",
  },
  ky: {
    description:
      "Ο απόλυτος παράδεισος κορυφαίων καταδύσεων μέσα στα απέραντα σαλαχιών.",
    landmarks: ["Stingray City", "Seven Mile Beach", "Βοτανικός Κήπος"],
    gastronomy: "Μοσχάρι στυλ Καϊμάν, τούρτα κασάβα.",
  },

  de: {
    description:
      "Η Γερμανία συνδυάζει την αστική νεωτερικότητα με τον ρομαντισμό των κάστρων της και του Μέλανα Δρυμού. Γνωστό για το δυναμισμό και την πλούσια ιστορία του.",
    gastronomy: "Bratwurst, pretzel, ξινολάχανο, μπύρα.",
    landmarks: [
      "Πύλη του Βρανδεμβούργου, Βερολίνο",
      "Κάστρο Neuschwanstein",
      "Καθεδρικός ναός της Κολωνίας",
      "Marienplatz, Μόναχο",
    ],
  },
  ch: {
    description:
      "Η Ελβετία είναι ένας αλπικός παράδεισος που προσφέρει καταγάλανες λίμνες, μεσαιωνικά φρούρια και εντυπωσιακά βουνά, ιδανικό για τους λάτρεις της φύσης και της άνεσης.",
    gastronomy: "Τυρί fondue, raclette, ελβετική σοκολάτα, rösti.",
    landmarks: [
      "Matterhorn",
      "Λίμνη της Γενεύης",
      "Κάστρο Chillon",
      "Jungfraujoch",
    ],
  },
  be: {
    description:
      "Στην καρδιά της Ευρώπης, το Βέλγιο είναι παγκοσμίως γνωστό για τις μαγευτικές μεσαιωνικές πόλεις του, την ευρωπαϊκή διπλωματία, τη σοκολάτα και τη μπύρα του.",
    gastronomy: "Βάφλες, πατάτες, μύδια, πραλίνες, μπύρες trappist.",
    landmarks: [
      "Grand Place των Βρυξελλών",
      "Καμπαναριό της Μπριζ",
      "Atomium",
      "Κάστρο Gravensteen",
    ],
  },
  hr: {
    description:
      "Η Κροατία προσφέρει πάνω από χίλια νησιά κατά μήκος της Αδριατικής Θάλασσας, διάσπαρτα με ρωμαϊκά αρχιτεκτονικά πετράδια και καταπράσινα εθνικά πάρκα.",
    gastronomy: "Ćevapi, χταπόδι σαλάτα, peka, νησιώτικα τυριά Pag.",
    landmarks: [
      "Τείχη του Ντουμπρόβνικ",
      "Εθνικό Πάρκο Λιμνών Plitvice",
      "Το παλάτι του Διοκλητιανού",
    ],
  },
  cy: {
    description:
      "Η Κύπρος είναι ένα θρυλικό νησί της Μεσογείου, η γενέτειρα της Αφροδίτης, που συνδυάζει παρθένες παραλίες με εντυπωσιακά αρχαία ερείπια.",
    gastronomy: "Χαλούμι, σουβλα, σεφταλιά, μουσακάς.",
    landmarks: [
      "Αρχαιολογικό Πάρκο Πάφου",
      "Ο Βράχος της Αφροδίτης",
      "Όρη Τρόοδος",
    ],
  },
  bg: {
    description:
      "Η Βουλγαρία είναι ένα βαλκανικό μωσαϊκό που συνδυάζει χρυσές ακτές της Μαύρης Θάλασσας, ορεινά εδάφη και μια απίστευτη θρακική κληρονομιά.",
    gastronomy: "Μπανίτσα, σαλάτα Shopska, ταρατόριο, βουλγαρικός μουσακάς.",
    landmarks: ["Μονή Ρίλα", "Καθεδρικός ναός Alexander Nevsky", "Sunny Beach"],
  },
  cz: {
    description:
      "Η Τσεχία συναρπάζει με τις πόλεις των εκατό κωδωνοστασίων, τις αιωνόβιες ζυθοποιίες και τα παραμυθένια κάστρα στην καρδιά της Κεντρικής Ευρώπης.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Γέφυρα του Καρόλου, Πράγα",
      "Κάστρο της Πράγας",
      "Οστεοφυλάκιο Sedlec",
      "Κάρλοβι Βάρι",
    ],
  },
  ee: {
    description:
      "Η Εσθονία είναι μια ψηφιακή πρωτοποριακή χώρα που φιλοξενεί τεράστια αρχέγονα δάση και μια ανέπαφη μεσαιωνική πρωτεύουσα με θέα στη Βαλτική.",
    gastronomy:
      "Verivorst (λουκάνικο αίματος), μαύρο ψωμί, παπαλίνα, craft μπύρα.",
    landmarks: [
      "Παλιά Πόλη του Ταλίν",
      "Εθνικό Πάρκο Lahemaa",
      "Κάστρο Χέρμαν",
    ],
  },
  fi: {
    description:
      "Η Φινλανδία, η χώρα των χιλίων λιμνών, φημίζεται για την αστραφτερή ερημιά της, το Βόρειο Σέλας στη Λαπωνία και τη ζωτική κουλτούρα της στη σάουνα.",
    gastronomy:
      "Καπνιστός σολομός, κρέας ταράνδου, ψωμί σίκαλης, καρελιώτικα γλυκά.",
    landmarks: ["Σουομενλίνα", "Χωριό Άγιου Βασίλη", "Εθνικό Πάρκο Nuuksio"],
  },
  ie: {
    description:
      "Η Ιρλανδία, το Emerald Isle, χαρακτηρίζεται από τους ανεμοδαρμένους βράχους, τη ζεστή κελτική μουσική και την φιλόξενη κουλτούρα της παμπ.",
    gastronomy: "Ιρλανδικό στιφάδο, Guinness, ψωμί με σόδα, colcannon.",
    landmarks: [
      "Βράχοι του Μοχέρ",
      "Αποθήκη Γκίνες",
      "Δαχτυλίδι του Κέρι",
      "Trinity College",
    ],
  },
  hu: {
    description:
      "Η Ουγγαρία διχοτομείται όμορφα από τον Δούναβη, γεμάτη από εντυπωσιακά ιαματικά λουτρά, ιστορικούς αμπελώνες και το μεγαλοπρεπές κοινοβούλιο.",
    gastronomy: "Goulash, Lángos, Paprikash κοτόπουλου, Tokaji κρασί.",
    landmarks: [
      "Βουλή της Βουδαπέστης",
      "Ιαματικά Λουτρά Széchenyi",
      "Κάστρο της Βούδας",
      "Λίμνη Μπάλατον",
    ],
  },
  lv: {
    description:
      "Η Λετονία μαγεύει με την πολυσύχναστη πρωτεύουσά της γεμάτη αρ νουβό αρχιτεκτονική και μίλια παρθένων παραλιών στις ακτές της Βαλτικής.",
    gastronomy:
      "Rupjmaize (μαύρο ψωμί σίκαλης), μπιζέλια με μπέικον, παπαλίνα.",
    landmarks: [
      "Παλιά Πόλη της Ρίγας",
      "House of the Blackheads",
      "Εθνικό Πάρκο Gauja",
    ],
  },
  lt: {
    description:
      "Η Λιθουανία είναι το νοτιότερο στολίδι της Βαλτικής, πλούσια σε παγετώδεις λίμνες, πυκνά δάση και συγκινητικές μαρτυρίες για το ταραχώδες παρελθόν της.",
    gastronomy:
      "Cepelinai (ντάμπλινγκ πατάτας), κρύα σούπα μπορς (šaltibarščiai).",
    landmarks: [
      "Κάστρο του νησιού Τρακάι",
      "Λόφος των Σταυρών",
      "Παλιά Πόλη του Βίλνιους",
    ],
  },
  lu: {
    description:
      "Το Λουξεμβούργο είναι ένα ακμάζον μεγάλο δουκικό μικροκράτος, του οποίου οι κοιλάδες είναι γεμάτες μεσαιωνικά κάστρα και η πρωτεύουσα είναι μια εντυπωσιακή ακρόπολη.",
    gastronomy: "Κρασιά Judd mat Gaardebounen, Gromperekichelcher, Moselle.",
    landmarks: ["Chemin de la Corniche", "Bock Casemates", "Κάστρο Vianden"],
  },
  mt: {
    description:
      "Η Μάλτα συνδυάζει άψογα τη ζεστασιά του μεσογειακού ήλιου και 7.000 ετών ναυτικής ιστορίας, φρούρια Ναΐτες και τιρκουάζ λιμνοθάλασσες.",
    gastronomy: "Παστίτσι, κουνέλι στιφάδο (Stuffat tal-fenek), φτύρα.",
    landmarks: [
      "Ο καθεδρικός ναός του Αγίου Ιωάννη",
      "Πόλη της Μντίνα",
      "Blue Lagoon (Comino)",
    ],
  },
  pl: {
    description:
      "Η Πολωνία είναι ο πολιτιστικός πυλώνας της Ανατολικής Ευρώπης, προικισμένη με επιβλητικές ανακαινισμένες πόλεις, το τραγικό μνημείο του Άουσβιτς και τα βουνά Τάτρα.",
    gastronomy: "Pierogi, bigos, kielbasa, πολωνική βότκα.",
    landmarks: [
      "Πλατεία Αγοράς Κρακοβίας",
      "Αλατωρυχείο Wieliczka",
      "Άουσβιτς-Μπίρκεναου",
      "Κάστρο Wawel",
    ],
  },
  ro: {
    description:
      "Με κυριαρχία του θρύλου του Δράκουλα, η Ρουμανία φιλοξενεί τα πολυτελή Καρπάθια Όρη, το μαγευτικό Δέλτα του Δούναβη και τις ζωντανές πόλεις της Τρανσυλβανίας.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Κάστρο Μπραν",
      "Κάστρο Πελές",
      "Δέλτα του Δούναβη",
      "Μέγαρο της Βουλής",
    ],
  },
  si: {
    description:
      "Η Σλοβενία ​​είναι ένας μικρός οικολογικός παράδεισος που φιλοξενεί τη μυθική λίμνη Bled, κολοσσιαία καρστικά σπήλαια και μια εξαιρετικά πράσινη πρωτεύουσα.",
    gastronomy: "Kranjska klobasa, potica (παξιμάδι), štrukli.",
    landmarks: [
      "Λίμνη Μπλεντ",
      "Σπήλαιο Postojna",
      "Κάστρο της Λιουμπλιάνας",
      "Εθνικό Πάρκο Triglav",
    ],
  },
  sk: {
    description:
      "Λιγότερο γνωστή, η Σλοβακία είναι ένας ορεινός θησαυρός με τον μεγαλύτερο αριθμό κάστρων κατά κεφαλήν στον κόσμο, εντός των High Tatras.",
    gastronomy: "Bryndzové halušky (νιόκι από πρόβειο τυρί), Kofola.",
    landmarks: ["Κάστρο της Μπρατισλάβα", "Υψηλά Τάτρα", "Κάστρο Spiš"],
  },
  se: {
    description:
      "Η Σουηδία ενσαρκώνει το σκανδιναβικό στυλ, απλώνεται σε υπέροχα αρχιπέλαγος, το βόρειο σέλας και μια πλούσια παράδοση κομψού σχεδιασμού.",
    gastronomy:
      "Κεφτεδάκια (Köttbullar), fika, σολομός gravlax, ρέγγα surströmming.",
    landmarks: [
      "Μουσείο Βάσα",
      "Πόλη του Βίσμπι",
      "Γκάμλα Σταν",
      "Icehotel Jukkasjärvi",
    ],
  },
  is: {
    description:
      "Η Ισλανδία, η χώρα της φωτιάς και του πάγου, χτυπά με δέος με τους θερμοπίδακες, τους τιτανικούς παγετώνες, τα ενεργά ηφαίστεια και τις γαλακτώδεις θερμές πηγές της.",
    gastronomy:
      "Hákarl (καρχαρίας που έχει υποστεί ζύμωση), Skyr, Ισλανδικό αρνί.",
    landmarks: [
      "Blue Lagoon",
      "Χρυσός Κύκλος",
      "Καταρράκτης Gullfoss",
      "Παραλία με μαύρη άμμο Reynisfjara",
    ],
  },
  no: {
    description:
      "Η Νορβηγία προσφέρει μια από τις πιο όμορφες γεωλογικές σκηνές του κόσμου: τα μαγευτικά αβυσσαλέα φιόρδ της που σκαλίζουν τη θάλασσα που περιβάλλεται από απόκρημνα βουνά.",
    gastronomy: "Σολομός, ρακφισκ, καστανό τυρί (Brunost), κρέας άλκες.",
    landmarks: [
      "Geirangerfjord",
      "Βόρειο Ακρωτήριο",
      "Νησιά Λοφότεν",
      "Μπρίγκεν",
    ],
  },
  al: {
    description:
      "Παλαιότερα ερμητική, η Αλβανία είναι το μυστικό στολίδι της Μεσογείου που βρίθει από κρυστάλλινα γαλάζια νερά, εντυπωσιακές Άλπεις και ελληνορωμαϊκά ερείπια.",
    gastronomy: "Byrek, fëgesë, θαλασσινά, μπακλαβάς.",
    landmarks: ["Αλβανική Ριβιέρα", "Berat", "Εθνικό Πάρκο Βουθρωτού"],
  },
  ad: {
    description:
      "Φωλιασμένο ψηλά στα Πυρηναία, αυτό το μικροσκοπικό πριγκιπάτο είναι ένα πραγματικό καταφύγιο για τους λάτρεις του σκι και της άγριας φύσης.",
    gastronomy: "Trinxat, escudella, αλλαντικά βουνού.",
    landmarks: ["Κοιλάδα Madriu-Perafita-Claror", "Caldea", "Grandvalira"],
  },
  at: {
    description:
      "Μια κατεξοχήν αλπική χώρα, η Αυστρία λάμπει με την απαράμιλλη κλασική μουσική, τα αυτοκρατορικά ανάκτορα και τα συναρπαστικά αλπικά τοπία της.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Ανάκτορο Schönbrunn", "Hofburg", "Άλπεις Kitzbühel"],
  },
  am: {
    description:
      "Η Αρμενία, ένα από τα παλαιότερα χριστιανικά έθνη του κόσμου, προσφέρει εντυπωσιακά ορεινά τοπία και μεγαλοπρεπή πέτρινα μοναστήρια σκαρφαλωμένα στην άκρη βαθιών φαραγγιών.",
    gastronomy: "Khorovats (αρμενικό μπάρμπεκιου), ντολμά, lavash, lahmajoun.",
    landmarks: ["Μονή Khor Virap", "Ναός του Γκάρνι", "Μονή Geghard"],
  },
  mc: {
    description:
      "Το Μονακό είναι η επιτομή της αίγλης στις ακτές της Μεσογείου, με πολυτελή γιοτ, το παγκοσμίου φήμης καζίνο του και το θρυλικό Grand Prix της Formula 1.",
    gastronomy: "Barbajuan, μονεγάσκο fougasse, stocafi.",
    landmarks: [
      "Καζίνο Μόντε Κάρλο",
      "Ο Βράχος του Μονακό",
      "Παλάτι του Πρίγκηπα",
      "Λιμάνι Ηρακλή",
    ],
  },
  by: {
    description:
      "Η Λευκορωσία εκπλήσσει με τη διατηρημένη φύση της, τα πυκνά παρθένα δάση (όπως η Bialowieza) που φιλοξενούν βίσωνες και τα μεσαιωνικά κάστρα με πλούσιο παρελθόν.",
    gastronomy: "Draniki (τηγανίτες πατάτας), machanka, kolduny.",
    landmarks: ["Κάστρο Μιρ", "Παλάτι Nesvizh", "Φρούριο της Βρέστης"],
  },
  az: {
    description:
      "Το Αζερμπαϊτζάν, η «Γη της Φωτιάς», είναι ένα συναρπαστικό μείγμα αρχαίας ιστορικής κληρονομιάς και αστραφτερών υπερσύγχρονων υποδομών στις ακτές της Κασπίας Θάλασσας.",
    gastronomy: "Plov, dolma, piti, qutab, μπακλαβάς.",
    landmarks: [
      "Flame Towers (Μπακού)",
      "Παλιά Πόλη (Icherisheher)",
      "Ηφαίστεια λάσπης Gobustan",
    ],
  },
  ge: {
    description:
      "Η Γεωργία προσφέρει μεγαλειώδη φύση στα βουνά του Καυκάσου, συναρπαστική αρχαία αρχιτεκτονική και τη φήμη της αρχαιότερης οινοποιητικής περιοχής στον κόσμο.",
    gastronomy: "Khachapuri, khinkali (ζυμαρικά), Churchkhela.",
    landmarks: [
      "Εκκλησία της Τριάδας Γεργέτης",
      "Παλιά Πόλη της Τιφλίδας",
      "Vardzia (Cave City)",
    ],
  },
  ba: {
    description:
      "Ένα σταυροδρόμι πολιτισμών στην καρδιά των Βαλκανίων όπου η Ανατολή συναντά τη Δύση. Θα ερωτευτείτε τα σμαραγδένια ποτάμια, τα απόκρημνα βουνά και τη διάσημη Παλιά Γέφυρα του Μόσταρ.",
    gastronomy: "Ćevapi, μπουρέκ, μπακλαβάς, βόσνιος καφές.",
    landmarks: [
      "Stari Most (Παλιά Γέφυρα)",
      "Baščaršija (Σαράγεβο)",
      "Καταρράκτες Kravica",
    ],
  },
  xk: {
    description:
      "Ένα νεαρό βαλκανικό έθνος, πλούσιο σε ιστορία και υπέροχα ορεινά τοπία, το Κοσσυφοπέδιο ξεχωρίζει με καλοδιατηρημένα ιστορικά οθωμανικά πετράδια και έναν πολύ φιλόξενο πληθυσμό.",
    gastronomy: "Flija, burek, qebapa, τυρί Šar.",
    landmarks: ["Μονή Visoki Dečani", "Παλιά Πρίζρεν", "Φαράγγι Rugova"],
  },
  li: {
    description:
      "Ένα από τα μικρότερα έθνη του κόσμου, το Λιχτενστάιν εκτείνεται μεταξύ Ελβετίας και Αυστρίας κατά μήκος της κοιλάδας του Ρήνου, όπου κυριαρχεί το όμορφο πριγκιπικό κάστρο και οι αλπικές κορυφές.",
    gastronomy: "Käsknöpfle (ζυμαρικά με τυρί), Ribel.",
    landmarks: [
      "Κάστρο Βαντούζ",
      "Μουσείο Καλών Τεχνών (Kunstmuseum)",
      "Χιονοδρομικό κέντρο Malbun",
    ],
  },
  me: {
    description:
      "Παρά το μικρό του μέγεθος, το Μαυροβούνιο κρύβει μερικά από τα πιο όμορφα τοπία της Αδριατικής Θάλασσας. Ο κόλπος του Κότορ συναντά εντυπωσιακά σκοτεινά βουνά (τα «μαύρα βουνά»).",
    gastronomy:
      "Brav u Mlijeku (αρνί σε γάλα), cevapi, καπνιστό προσούτο Njeguši.",
    landmarks: ["Κόλπος του Κότορ", "Εθνικό Πάρκο Durmitor", "Sveti Stefan"],
  },
  md: {
    description:
      "Η Μολδαβία, ο κρυμμένος θησαυρός της Ανατολικής Ευρώπης, προσελκύει αναπόφευκτα τους λάτρεις του οινοτουρισμού με τα τεράστια υπόγεια κελάρια και τα προγονικά λαξευμένα μοναστήρια σε βράχο.",
    gastronomy:
      "Mămăligă (πολέντα), plăcinte (γεμιστά αρτοσκευάσματα), sarmale.",
    landmarks: [
      "Orheiul Vechi (Μονή Σπηλαίων)",
      "Οινοποιεία Cricova",
      "Mileştii Mici Cellars",
    ],
  },
  mk: {
    description:
      "Στην καρδιά των Βαλκανίων, η Βόρεια Μακεδονία θαμπώνει με την απίστευτα καθαρή αρχαία λίμνη Οχρίδα, την ορθόδοξη κληρονομιά της και τα διατηρημένα εθνικά πάρκα.",
    gastronomy: "Tavče gravče (φασόλια φούρνου), ajvar, pastrmajlija.",
    landmarks: [
      "Λίμνη Οχρίδα",
      "Εκκλησία του Αγίου Ιωάννη στο Κάνεο",
      "Φαράγγι Μάτκα",
    ],
  },
  it: {
    description:
      "Η Ιταλία είναι ένα υπαίθριο μουσείο. Ανάμεσα στα ρωμαϊκά ερείπια, τη Φλωρεντινή Αναγέννηση, τα ενετικά κανάλια και μια γραφική ακτογραμμή, η χώρα προσφέρει ένα αξέχαστο ταξίδι.",
    gastronomy: "Ζυμαρικά, πίτσα, gelato, εσπρέσο, τιραμισού.",
    landmarks: [
      "Κολοσσαίο, Ρώμη",
      "Πύργος της Πίζας",
      "Καθεδρικός ναός της Φλωρεντίας",
      "Μεγάλο Κανάλι, Βενετία",
    ],
    overseas: ["Σικελία", "Σαρδηνία"],
  },
  sm: {
    description:
      "Σκαρφαλωμένο στο όρος Τιτάνο και εντελώς κλειστό από την Ιταλία, ο Άγιος Μαρίνος διεκδικεί τον τίτλο της παλαιότερης δημοκρατίας και του κυρίαρχου συνταγματικού κράτους στον κόσμο.",
    gastronomy:
      "Torta Tre Monti (Κέικ Τρία Βουνά), piadina, φασόλια με φλούδες χοιρινού κρέατος.",
    landmarks: [
      "Οι Τρεις Πύργοι (Guaita, Cesta, Montale)",
      "Βασιλική του Αγίου Μαρίνου",
      "Piazza della Libertà",
    ],
  },
  gb: {
    description:
      "Το Ηνωμένο Βασίλειο προσφέρει ένα μοναδικό μείγμα μοναρχικής παράδοσης, πολιτιστικής πρωτοπορίας, εντυπωσιακών τοπίων της Σκωτίας και ιστορικών πόλεων.",
    gastronomy: "Fish and chips, roast beef, πουτίγκα Yorkshire, τσάι.",
    landmarks: [
      "Μπιγκ Μπεν και Παλάτι του Γουέστμινστερ",
      "Στόουνχεντζ",
      "Πύργος του Λονδίνου",
      "Κάστρο του Εδιμβούργου",
    ],
    overseas: ["Βερμούδα", "Νησιά Κέιμαν", "Γιβραλτάρ"],
  },
  pt: {
    description:
      "Η Πορτογαλία μαγεύει με τα πολύχρωμα δρομάκια της, τις παραλίες με τον Ατλαντικό και την εξαιρετική φιλοξενία των κατοίκων της, με τη συναρπαστική μελωδία του Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, κρασί Port.",
    landmarks: [
      "Πύργος Belém, Λισαβόνα",
      "Ribeira, Πόρτο",
      "Pena Palace, Σίντρα",
      "Παραλίες Αλγκάρβε",
    ],
    overseas: ["Μαδέρα", "Αζόρες"],
  },
  gr: {
    description:
      "Η Ελλάδα, κοιτίδα του δυτικού πολιτισμού, σας προσκαλεί σε ένα μυθολογικό ταξίδι, από την Ακρόπολη στα υπέροχα κρυστάλλινα νερά των Κυκλάδων.",
    gastronomy: "Μουσακάς, σουβλάκι, ελληνική σαλάτα, τζατζίκι.",
    landmarks: ["Ακρόπολη Αθηνών", "Θήρα", "Μετέωρα", "Ανάκτορο Κνωσού"],
    overseas: ["Κρήτη", "Ρόδος"],
  },
  dk: {
    description:
      "Η Δανία αντιπροσωπεύει την έννοια του «Hygge»: μια ειρηνική σκανδιναβική χώρα, πρωτοπόρος στο σχεδιασμό, γεμάτη ποδηλατόδρομους και βασιλικά ανάκτορα.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, μπύρα Carlsberg.",
    landmarks: ["Κήποι Tivoli", "Nyhavn", "Η Μικρή Γοργόνα", "Κάστρο Kronborg"],
    overseas: ["Νησιά Φερόε", "Γροιλανδία"],
  },
  nl: {
    description:
      "Η Ολλανδία φημίζεται για τα επίπεδα τοπία, τα δαιδαλώδη κανάλια, τα λιβάδια με τουλίπες και τους εμβληματικούς ανεμόμυλους.",
    gastronomy: "Gouda, stroopwafel, ωμή ρέγγα, poffertjes.",
    landmarks: [
      "Κανάλια του Άμστερνταμ",
      "Κήποι Keukenhof",
      "Ανεμόμυλοι Kinderdijk",
      "Μουσείο Βαν Γκογκ",
    ],
    overseas: ["Αρούμπα", "Κουράσω"],
  },
  rs: {
    description:
      "Η Σερβία συνδυάζει την έντονη νυχτερινή ζωή του Βελιγραδίου στον Δούναβη, το δραματικό φρούριο Petrovaradin και τα υπέροχα κρυμμένα ορθόδοξα μοναστήρια.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (κονιάκ φρούτων).",
    landmarks: [
      "Φρούριο Βελιγραδίου (Kalemegdan)",
      "Φρούριο Golubac",
      "Ναός του Αγίου Σάββα",
    ],
  },
  va: {
    description:
      "Το Βατικανό, το μικρότερο κυρίαρχο κράτος του κόσμου, κατοικεί στην καρδιά της Ρώμης και λειτουργεί ως η πνευματική έδρα της Καθολικής Εκκλησίας, φιλοξενώντας εκπληκτικά καλλιτεχνικά αριστουργήματα του Μιχαήλ Άγγελου.",
    gastronomy:
      "Χωρίς αποκλειστική κουζίνα. διαθέτει παραδοσιακή ρωμαϊκή γαστρονομία.",
    landmarks: [
      "Βασιλική του Αγίου Πέτρου",
      "Καπέλα Σιξτίνα",
      "Μουσεία του Βατικανού",
    ],
  },
  fr: {
    description:
      "Η Γαλλία είναι ο κορυφαίος τουριστικός προορισμός στον κόσμο, φημισμένη για την εξαιρετική της κληρονομιά, τα διαφορετικά τοπία που κυμαίνονται από τη Γαλλική Ριβιέρα έως τις κορυφές των Άλπεων και μια ασύγκριτη τέχνη de vivre.",
    gastronomy: "Μπαγκέτα, τυριά, κρασί, κρουασάν, βοδινό bourguignon.",
    landmarks: [
      "Πύργος του Άιφελ, Παρίσι",
      "Mont Saint-Michel",
      "Κάστρα της κοιλάδας του Λίγηρα",
      "Γαλλική Ριβιέρα",
    ],
    overseas: [
      "Γουαδελούπη",
      "Μαρτινίκα",
      "Γαλλική Γουιάνα",
      "Ξανασμίξιμο",
      "Μαγιότ",
      "Γαλλική Πολυνησία",
      "Νέα Καληδονία",
    ],
  },
  es: {
    description:
      "Η Ισπανία μαγεύει με το ηλιόλουστο κλίμα, τη ζωντανή κουλτούρα από τις σιέστες μέχρι το φλαμένκο, τις υπέροχες παραλίες και τη μοναδική ιστορική αρχιτεκτονική, ειδικά τη μαυριτανική κληρονομιά της.",
    gastronomy: "Τάπας, παέγια, ζαμπόν Ιβηρικής, γκασπάτσο, σαγκρία.",
    landmarks: [
      "Sagrada Familia, Βαρκελώνη",
      "Αλάμπρα, Γρανάδα",
      "Βασιλικό Παλάτι της Μαδρίτης",
      "Plaza de España, Σεβίλλη",
    ],
    overseas: ["Κανάριοι Νήσοι", "Βαλεαρίδες Νήσοι", "Θέουτα", "Μελίλλα"],
  },
};
